// extracted by mini-css-extract-plugin
export default {"root":"PersonalisedMenteeEmailersTableBody_root__RfgjQ","manageCommsLearner":"PersonalisedMenteeEmailersTableBody_manageCommsLearner__WgsJC"};